__turbopack_context__.v({
  "addons-box-header-legal-icon": "EmailSignatureEditorAddonsLegalDisclaimerBox-module-scss-module__N66yHW__addons-box-header-legal-icon",
  "addons-selector-legal-textarea": "EmailSignatureEditorAddonsLegalDisclaimerBox-module-scss-module__N66yHW__addons-selector-legal-textarea",
});
